import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import BorderCard from '@components/cards/border';

import AIKO_IMG from '@images/authors/yao.jpeg';
import CHIBAWAN_IMG from '@images/interviewees/chibawanlogo.png';
import JURI_IMG from '@images/interviewees/edwards_juri.jpeg';
import ERI_IMG from '@images/interviewees/eri_nishihira.jpg';
import MASATO_IMG from '@images/interviewees/masato.jpg';
import MEGUMI_IMG from '@images/interviewees/megumi.jpg';
import RIKA_IMG from '@images/interviewees/rika.png';
import WEATHER_IMG from '@images/interviewees/tokyo_dog_cat_weather.jpg';
import YOSHIHIRO_IMG from '@images/interviewees/yoshihiro.jpg';

import * as styles from './styles.module.scss';

const INTERVIEWEE_IMGS = {
        エドワーズ壽里: JURI_IMG,
        西平衣里さん: ERI_IMG,
        草刈亜以子さん: AIKO_IMG,
        中里めぐ美さん: MEGUMI_IMG,
        伊藤雅人先生: MASATO_IMG,
        田中りかさん: RIKA_IMG,
        東京犬猫日和さん: WEATHER_IMG,
        恩地祥博さん: YOSHIHIRO_IMG,
        ちばわん: CHIBAWAN_IMG,
    } as any,
    TRANSLATION_HREF = {
        草刈亜以子さん: [
            null,
            'https://www.yokohamasupdogs.com/',
            'https://www.sankotsu.yokohama/',
            'https://sup-j.org/',
            'https://sup-j.org/instructors/level2/%e8%8d%89%e5%88%88%e4%ba%9c%e4%bb%a5%e5%ad%90%ef%bc%88aiko-kusakari%ef%bc%89/',
        ],
        中里めぐ美さん: [
            'https://dogyoga-wan.com/',
            'https://www.pet-bunka.net/s_kango/index.html',
            'https://www.pet-bunka.net/s_kaigo/index.html',
            'https://www.pet-bunka.net/s_sitter/index.html',
        ],
        伊藤雅人先生: [
            'https://camec-ad.jp/?utm_source=wantimes&utm_medium=blog&utm_campaign=drito',
            'https://www.jsvd.jp/',
            'https://www.saaivm.com/',
        ],
        田中りかさん: ['https://www.autocamp.or.jp/'],
        恩地祥博さん: [null, 'https://graygraygray.jp/'],
    } as { [key: string]: string[] };

type Props = {
    interviewee: string;
    isAmp?: boolean;
};

const IntervieweeSlice: FC<Props> = ({ interviewee, isAmp = false }) => {
    const { t } = useTranslation();

    const transLink = (href: string) => <a href={href} target="_blank" rel="noreferrer" />;

    const intervieweeName = () => {
        if (interviewee === 'ちばわん') {
            return (
                <a href="https://chibawan.net/" target="_blank" rel="noreferrer">
                    {interviewee}
                </a>
            );
        }
        if (interviewee === '恩地祥博さん') {
            return (
                <a href="https://www.instagram.com/onccchi/" target="_blank" rel="noreferrer">
                    {interviewee}
                </a>
            );
        }
        return interviewee;
    };

    return (
        <div className={styles['interviewee_card']}>
            <span>{t('interviewees.span')}</span>
            <BorderCard
                name={intervieweeName()}
                image={INTERVIEWEE_IMGS[interviewee]}
                job_title={
                    <Trans
                        i18nKey={`interviewees.${interviewee}.job_title`}
                        components={{
                            link1: transLink(TRANSLATION_HREF[interviewee]?.[0]),
                        }}
                    />
                }
                description={
                    <Trans
                        i18nKey={`interviewees.${interviewee}.description`}
                        components={{
                            link2: transLink(TRANSLATION_HREF[interviewee]?.[1]),
                            link3: transLink(TRANSLATION_HREF[interviewee]?.[2]),
                            link4: transLink(TRANSLATION_HREF[interviewee]?.[3]),
                            link5: transLink(TRANSLATION_HREF[interviewee]?.[4]),
                        }}
                    />
                }
                isAmp={isAmp}
            />
        </div>
    );
};

export default IntervieweeSlice;
